export default __webpack_public_path__ + "static/media/biblio-off.2c11c8f4.svg";